import React from 'react'
import image3 from '../jb.jpeg';
const Navbar = () => {
    return (
        
        <nav className="navbar navbar-expand-lg navbar-light bg-dark">
            <div class="container">
                   <img className="round-image" src={image3}/>
       
  {/* <a className="navbar-brand" href="#">Jatin Bindra</a> */}
  <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
  <i class="fas fa-bars" color="#ffffff"></i>
  </button>

  <div className="collapse navbar-collapse" id="navbarSupportedContent">
    <ul className="navbar-nav ml-auto">
      <li className="nav-item active">
        <a className="nav-link" href="/">Home <span className="sr-only">(current)</span></a>
      </li>
      <li className="nav-item">
        <a className="nav-link" href="/aboutme">About me</a>
      </li>
      <li className="nav-item">
        <a className="nav-link" href="/experience">Experience</a>
      </li>
      <li className="nav-item">
        <a className="nav-link" href="/projects">Projects</a>
      </li>
      <li className="nav-item">
        <a className="nav-link" href="/accomplishments"> Accomplishments</a>
      </li>
        <li className="nav-item">
        <a className="nav-link" href="/wall-of-fame">Wall of fame</a>
      </li>
      <li className="nav-item">
        <a className="nav-link" href="/contact">Contact me</a>
      </li>
    
   

    </ul>
    
  </div>
  </div>
</nav>
    )
}

export default Navbar
